<template>
  <v-card
    border
    class="rounded-lg"
  >
    <div
      style="height: 170px"
      class="blue-grey lighten-5 pa-0 position-relative"
    >
      <div
        v-if="icon && (showIcon || !optimizedThumbnailUrl)"
        class="pa-10"
      >
        <r-img
          :src="icon"
          height="100px"
        />
      </div>
      <r-img
        v-else
        :src="optimizedThumbnailUrl"
        class="blue-grey lighten-5"
        height="170px"
        @error="handleImageError"
      />
      <v-chip
        v-if="isNew"
        color="primary"
        size="small"
        class="position-absolute top-0 right-0 ma-2"
      >
        {{ $t('labels.new') }}
      </v-chip>
    </div>

    <v-divider />
    <v-tooltip
      location="top"
      v-if="caption"
    >
      <template v-slot:activator="{ props }">
        <span
          v-bind="props"
          class="text-truncate w-100 text-caption px-2"
          v-text="caption"
        />
      </template>
      <span>{{ caption }}</span>
    </v-tooltip>

    <v-card-actions
      class="white py-1"
      :style="{ 'margin-top': caption ? '-18px' : undefined }"
    >
      <v-tooltip location="top">
        <template v-slot:activator="{ props }">
          <span
            v-bind="props"
            class="flex-grow-1 text-truncate"
            v-text="name"
          />
        </template>
        <span>{{ name }}</span>
      </v-tooltip>

      <v-btn
        v-if="topicId"
        icon
        :to="{ name: 'content-creator', query: { topicId: topicId } }"
      >
        <v-icon>mdi-brain</v-icon>
      </v-btn>
      <v-btn
        icon
        :href="url"
      >
        <v-icon>mdi-download</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { setQueryParams } from '@/lib/url'

export default {
  props: {
    caption: { type: String, default: '' },
    name: { type: String, required: true },
    url: { type: String, required: true },
    icon: { type: String, default: '' },
    thumbnailUrl: { type: String, default: '' },
    topicId: { type: String, default: '' },
    isNew: { type: Boolean, default: false },
  },

  data() {
    return {
      showIcon: false,
    }
  },

  computed: {
    optimizedThumbnailUrl() {
      if (this.thumbnailUrl) {
        return this.setQueryParams(this.thumbnailUrl, { h: 340 })
      }
      return null
    },
  },
  methods: {
    setQueryParams,
    handleImageError() {
      this.showIcon = true
    },
  },
}
</script>
<style scoped>
.v-card-actions {
  gap: unset;
}
.v-btn {
  padding-left: 0;
  padding-right: 0;
  width: calc(var(--v-btn-height));
}
.text-caption {
  font-style: italic;
}
</style>
